var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"customize"},[_c('img',{attrs:{"src":require("@/assets/img/end.png"),"alt":""}}),_c('span',{on:{"click":_vm.changeShowPrescription}},[_vm._v("去定制你的运动计划")])])
}
var staticRenderFns = []

export { render, staticRenderFns }